/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductAttachmentSnapshotFragmentDoc, AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductListItems_Product_PimCustomSupplierProduct_Fragment = { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> };

export type ProductListItems_Product_PimSupplierProduct_Fragment = { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> };

export type ProductListItems_ProductFragment = ProductListItems_Product_PimCustomSupplierProduct_Fragment | ProductListItems_Product_PimSupplierProduct_Fragment;

export type ProductListItems_ProductListItemFragment = { __typename: 'ProductListItem', id: string, supplierId: string, articleNumber: string, quantity: number, rank: number, product?: { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | null };

export type ProductListItemsQueryVariables = Types.Exact<{
  productListId: Types.Scalars['ID']['input'];
}>;


export type ProductListItemsQuery = { productListItems: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProductListItemConnection', totalCount: number, edges: Array<{ __typename: 'ProductListItemEdge', node: { __typename: 'ProductListItem', id: string, supplierId: string, articleNumber: string, quantity: number, rank: number, product?: { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | null } }> } };

export type AddProductsToProductListMutationVariables = Types.Exact<{
  input: Types.AddProductsToProductListInput;
}>;


export type AddProductsToProductListMutation = { addProductsToProductList: { __typename: 'AddProductsToProductListResult', productListItems: Array<{ __typename: 'ProductListItem', id: string, supplierId: string, articleNumber: string, quantity: number, rank: number, product?: { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | null }> } };

export type UpdateProductListItemQuantityMutationVariables = Types.Exact<{
  input: Types.UpdateProductListItemQuantityInput;
}>;


export type UpdateProductListItemQuantityMutation = { updateProductListItemQuantity: { __typename: 'UpdateProductListItemQuantityResult', productListItem: { __typename: 'ProductListItem', id: string, supplierId: string, articleNumber: string, quantity: number, rank: number, product?: { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, id: string, articleNumber: string, supplier: { __typename: 'PimSupplier', id: string, title: string }, pricing?: { __typename: 'PimPricing', netPrice?: number | null, listPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', id: string, title: string } } | null, texts?: { __typename: 'PimProductTexts', id: string, title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | null } } };

export type RemoveProductFromProductListMutationVariables = Types.Exact<{
  input: Types.RemoveProductFromProductListInput;
}>;


export type RemoveProductFromProductListMutation = { removeProductFromProductList: { __typename: 'RemoveProductFromProductListResult', ok: boolean } };

export type SetProductListItemsOrderMutationVariables = Types.Exact<{
  input: Types.SetProductListItemsOrderInput;
}>;


export type SetProductListItemsOrderMutation = { setProductListItemsOrder: { __typename: 'SetProductListItemsOrderResult', ok: boolean } };

export const ProductListItems_ProductFragmentDoc = gql`
    fragment ProductListItems_Product on Product {
  id
  articleNumber
  branding {
    brand {
      id
      title
    }
  }
  texts {
    id
    title
    description
    extendedDescription
  }
  attachments {
    ...ProductAttachmentSnapshot
  }
  ... on PimSupplierProduct {
    supplierId
    manufacturerArticleNumber
    supplier {
      id
      title
    }
    pricing {
      netPrice
      listPrice
    }
    status {
      value
    }
  }
  ... on PimCustomSupplierProduct {
    supplierId
    manufacturerArticleNumber
    supplier {
      id
      title
    }
    pricing {
      netPrice
      listPrice
    }
    status {
      value
    }
  }
}
    ${ProductAttachmentSnapshotFragmentDoc}`;
export const ProductListItems_ProductListItemFragmentDoc = gql`
    fragment ProductListItems_ProductListItem on ProductListItem {
  id
  supplierId
  articleNumber
  quantity
  rank
  product {
    ...ProductListItems_Product
  }
}
    ${ProductListItems_ProductFragmentDoc}`;
export const ProductListItemsDocument = gql`
    query ProductListItems($productListId: ID!) {
  productListItems(productListId: $productListId) {
    ... on ProductListItemConnection {
      edges {
        node {
          ...ProductListItems_ProductListItem
        }
      }
      totalCount
    }
  }
}
    ${ProductListItems_ProductListItemFragmentDoc}`;

/**
 * __useProductListItemsQuery__
 *
 * To run a query within a React component, call `useProductListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListItemsQuery({
 *   variables: {
 *      productListId: // value for 'productListId'
 *   },
 * });
 */
export function useProductListItemsQuery(baseOptions: Apollo.QueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables> & ({ variables: ProductListItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
      }
export function useProductListItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
        }
export function useProductListItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
        }
export type ProductListItemsQueryHookResult = ReturnType<typeof useProductListItemsQuery>;
export type ProductListItemsLazyQueryHookResult = ReturnType<typeof useProductListItemsLazyQuery>;
export type ProductListItemsSuspenseQueryHookResult = ReturnType<typeof useProductListItemsSuspenseQuery>;
export type ProductListItemsQueryResult = Apollo.QueryResult<ProductListItemsQuery, ProductListItemsQueryVariables>;
export const AddProductsToProductListDocument = gql`
    mutation AddProductsToProductList($input: AddProductsToProductListInput!) {
  addProductsToProductList(input: $input) {
    productListItems {
      ...ProductListItems_ProductListItem
    }
  }
}
    ${ProductListItems_ProductListItemFragmentDoc}`;
export type AddProductsToProductListMutationFn = Apollo.MutationFunction<AddProductsToProductListMutation, AddProductsToProductListMutationVariables>;

/**
 * __useAddProductsToProductListMutation__
 *
 * To run a mutation, you first call `useAddProductsToProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToProductListMutation, { data, loading, error }] = useAddProductsToProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToProductListMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToProductListMutation, AddProductsToProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToProductListMutation, AddProductsToProductListMutationVariables>(AddProductsToProductListDocument, options);
      }
export type AddProductsToProductListMutationHookResult = ReturnType<typeof useAddProductsToProductListMutation>;
export type AddProductsToProductListMutationResult = Apollo.MutationResult<AddProductsToProductListMutation>;
export type AddProductsToProductListMutationOptions = Apollo.BaseMutationOptions<AddProductsToProductListMutation, AddProductsToProductListMutationVariables>;
export const UpdateProductListItemQuantityDocument = gql`
    mutation UpdateProductListItemQuantity($input: UpdateProductListItemQuantityInput!) {
  updateProductListItemQuantity(input: $input) {
    productListItem {
      ...ProductListItems_ProductListItem
    }
  }
}
    ${ProductListItems_ProductListItemFragmentDoc}`;
export type UpdateProductListItemQuantityMutationFn = Apollo.MutationFunction<UpdateProductListItemQuantityMutation, UpdateProductListItemQuantityMutationVariables>;

/**
 * __useUpdateProductListItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateProductListItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductListItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductListItemQuantityMutation, { data, loading, error }] = useUpdateProductListItemQuantityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductListItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductListItemQuantityMutation, UpdateProductListItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductListItemQuantityMutation, UpdateProductListItemQuantityMutationVariables>(UpdateProductListItemQuantityDocument, options);
      }
export type UpdateProductListItemQuantityMutationHookResult = ReturnType<typeof useUpdateProductListItemQuantityMutation>;
export type UpdateProductListItemQuantityMutationResult = Apollo.MutationResult<UpdateProductListItemQuantityMutation>;
export type UpdateProductListItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateProductListItemQuantityMutation, UpdateProductListItemQuantityMutationVariables>;
export const RemoveProductFromProductListDocument = gql`
    mutation RemoveProductFromProductList($input: RemoveProductFromProductListInput!) {
  removeProductFromProductList(input: $input) {
    ok
  }
}
    `;
export type RemoveProductFromProductListMutationFn = Apollo.MutationFunction<RemoveProductFromProductListMutation, RemoveProductFromProductListMutationVariables>;

/**
 * __useRemoveProductFromProductListMutation__
 *
 * To run a mutation, you first call `useRemoveProductFromProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductFromProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductFromProductListMutation, { data, loading, error }] = useRemoveProductFromProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProductFromProductListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductFromProductListMutation, RemoveProductFromProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductFromProductListMutation, RemoveProductFromProductListMutationVariables>(RemoveProductFromProductListDocument, options);
      }
export type RemoveProductFromProductListMutationHookResult = ReturnType<typeof useRemoveProductFromProductListMutation>;
export type RemoveProductFromProductListMutationResult = Apollo.MutationResult<RemoveProductFromProductListMutation>;
export type RemoveProductFromProductListMutationOptions = Apollo.BaseMutationOptions<RemoveProductFromProductListMutation, RemoveProductFromProductListMutationVariables>;
export const SetProductListItemsOrderDocument = gql`
    mutation SetProductListItemsOrder($input: SetProductListItemsOrderInput!) {
  setProductListItemsOrder(input: $input) {
    ok
  }
}
    `;
export type SetProductListItemsOrderMutationFn = Apollo.MutationFunction<SetProductListItemsOrderMutation, SetProductListItemsOrderMutationVariables>;

/**
 * __useSetProductListItemsOrderMutation__
 *
 * To run a mutation, you first call `useSetProductListItemsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductListItemsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductListItemsOrderMutation, { data, loading, error }] = useSetProductListItemsOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProductListItemsOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetProductListItemsOrderMutation, SetProductListItemsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProductListItemsOrderMutation, SetProductListItemsOrderMutationVariables>(SetProductListItemsOrderDocument, options);
      }
export type SetProductListItemsOrderMutationHookResult = ReturnType<typeof useSetProductListItemsOrderMutation>;
export type SetProductListItemsOrderMutationResult = Apollo.MutationResult<SetProductListItemsOrderMutation>;
export type SetProductListItemsOrderMutationOptions = Apollo.BaseMutationOptions<SetProductListItemsOrderMutation, SetProductListItemsOrderMutationVariables>;